<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <span class="flex-grow-1" v-if="name"><b>{{ $t('memberIntro') }}</b> {{name}}</span>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <div class="d-flex flex-wrap">
                    <!-- Image -->
                    <div role="group" class="form-group col-12">
                        <GalleryPicker class="gallery-picker" v-model="hero.image" :ratioWidth="16" :ratioHeight="9" v-bind:class="{'is-invalid': genericValidator(hero.image) === false || errorValidator('Image') === false }" :max="1"></GalleryPicker>
                    </div>
                    <!-- Titles -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('titleMandatory') }}</label>
                        <CInput type="text" v-model="hero.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(hero.titles) && errorValidator('Titles')"></CInput>
                    </div>
                    <!-- Contents -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('contentMandatory') }}</label>
                        <CInput type="text" v-model="hero.contents[currentLanguage.key]" :invalid-feedback="errorOutput['Contents']" :is-valid="genericValidator(hero.contents) && errorValidator('Contents')"></CInput>
                    </div>
                    <!-- type -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('typeMandatory') }}</label>
                        <SingleOptionDropdown v-model="hero.type" :options="type" :title="$t('Type')" :is-valid="genericValidator(hero.type) && errorValidator('Type')" :invalid-feedback="errorOutput['Type']"></SingleOptionDropdown>
                    </div>
                    <!-- ButtonContents -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('buttonContentMandatory') }}</label>
                        <CInput type="text" v-model="hero.buttonContents[currentLanguage.key]" :invalid-feedback="errorOutput['ButtonContents']" :is-valid="genericValidator(hero.buttonContents) && errorValidator('ButtonContents')"></CInput>
                    </div>
                    <!-- ButtonUrl -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('buttonUrlMandatory') }}</label>
                        <CInput type="text" v-model="hero.buttonUrl" :invalid-feedback="errorOutput['ButtonUrl']" :is-valid="genericValidator(hero.buttonUrl) && errorValidator('ButtonUrl')"></CInput>
                    </div>  
                </div>
                <!-- Action button + submitting -->  
                <div role="group" class="form-group col-12 d-flex justify-content-end">
                    <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                    <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                </div>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import Hero from "@/classes/Hero";
import { mapState } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue'
import FormLoading from '@/controls/FormLoading.vue'
import { API_HELPER } from "@/helpers/api.js";
import SingleOptionDropdown from '../controls/SingleOptionDropdown.vue'

  export default {
  components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, FormLoading, SingleOptionDropdown },
    props:{    
        baseHero:
        {
            type: Object,
            default: null,
        },
        baseHeroName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            triedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            hero: new Hero({}, {}, {}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            type: [{label: this.$t("home"), key: "Home"}, {label: this.$t("products"), key: "Products"}, {label: this.$t("experiences"), key: "Experiences"}, {label: this.$t("about"), key: "About"}, {label: this.$t("soenga"), key: "Soenga"}, {label: this.$t("center"), key: "Center"}],
        }
    },
    mounted: function()
    {
        this.resetHero();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate multilanguage fields
            for (const [key, value] of Object.entries(this.hero.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.hero.contents)) { if(!value) { result['Contents'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.hero.buttonContents)) { if(!value) { result['ButtonContents'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        ...mapState('heros', ['postHeroOutput']),
        ...mapState('heros', ['putHerosOutput']),
        name: function()
        {
            return this.baseHero || this.baseHeroName ? (this.baseHero ? this.baseHero.name : this.baseHeroName) : null;
        }
    },
    methods:{
        resetHero(){
            if(!this.baseHero)
            {
                var titles = {}; var contents = {}; var buttonContents = {};
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; contents[language.key] = ""; buttonContents[language.key] = ""; });

                this.hero = new Hero(titles, contents, buttonContents);
            }
            else
            {
                this.hero = deepClone(new Hero, this.baseHero);         
                this.hero.image = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.hero.image])};     
            }
        },
        submitClicked(){
            this.triedSubmit = true;
            // Emit event
            if(this.hero.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.hero);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "HerosList" });
        },
    },
    watch:
    {
        postHeroOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        putHerosOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseHero: function()
        {
            this.resetHero();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

    .showDropdown
    {
        display: block !important;
    }

    .input-group-append
    {
      height: fit-content;
    }

    img
    {
        width: 50%;
        height: 50%;
    }

</style> 